var exports = {
  "vK": "ReportFlowBanner.module__banner___Z2VSSV",
  "Kk": "ReportFlowBanner.module__icon___Z2VSSV",
  "Qq": "ReportFlowBanner.module__text___Z2VSSV",
};

module.exports = exports;
